module.exports = __webpack_public_path__ + "static/img/slide-4.6e551f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/temp/slide-4.jpg
// module id = 511
// module chunks = 1